import { Api } from "../config/request";

const getZoneTokens = async (data) => {
    let response = await Api.PostRequest("/getZoneTokens", data);
    return response.data;
};

const getAllPurchasedOrMyCartTokens = async (data) => {
    let response = await Api.PostRequest("/getAllPurchasedOrMyCartTokens", data);
    return response.data;
};

const getMatchesList = async (data) => {
    let response = await Api.PostRequest("/getMatchesList", data);
    return response.data;
};

const getLiveMatchesList = async (data) => {
    let response = await Api.PostRequest("/getLiveMatchesList", data);
    return response.data;
};

const getUserOwnedTokensList = async (data) => {
    let response = await Api.PostRequest("/getUserTokens", data);
    return response.data;
};


const sportApi = {
    getZoneTokens,
    getMatchesList,
    getLiveMatchesList,
    getUserOwnedTokensList,
    getAllPurchasedOrMyCartTokens
};

export default sportApi;
